"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/OnCall/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _lodash = require('lodash');




var _CallControls = require('web/components/VideoCall/CallControls');



var _uiUtils = require('web/components/VideoCall/OnCall/uiUtils');
var _videoCall = require('web/services/videoCall');
var _DesktopMoreOptionsModal = require('./DesktopMoreOptionsModal'); var _DesktopMoreOptionsModal2 = _interopRequireDefault(_DesktopMoreOptionsModal);
var _ShareOverlay = require('./ShareOverlay'); var _ShareOverlay2 = _interopRequireDefault(_ShareOverlay);
var _SpeakerNameBar = require('./SpeakerNameBar'); var _SpeakerNameBar2 = _interopRequireDefault(_SpeakerNameBar);
var _ParticipantsBoard = require('./ParticipantsBoard'); var _ParticipantsBoard2 = _interopRequireDefault(_ParticipantsBoard);
var _CallControls3 = require('./CallControls'); var _CallControls4 = _interopRequireDefault(_CallControls3);
var _CallContent = require('./CallContent'); var _CallContent2 = _interopRequireDefault(_CallContent);

// A call participant as screens/VideoCall/OnCall builds it: the Daily
// participant plus the room user's details, a screen-share entry, or a
// placeholder for a room user who is still connecting.











const tooltipWrapperClassName = "meeting--on-call--tooltip"
const PinActiveSpeakerBtnWithTooltip =
  _uiUtils.withOnCallTooltip.call(void 0, 'bottom', 'Pin video', tooltipWrapperClassName)(_uiUtils.withTouchInterception.call(void 0, _CallControls.PinActiveSpeakerBtn))
const MinimizeCallBtnWithTooltip =
  _uiUtils.withOnCallTooltip.call(void 0, 'bottom', 'Minimize call', tooltipWrapperClassName)(_uiUtils.withTouchInterception.call(void 0, _CallControls.MinimizeCallBtn))
const RemoveParticipantBtnWithTooltip =
  _uiUtils.withOnCallTooltip.call(void 0, 'top', 'Remove participant', tooltipWrapperClassName)(_uiUtils.withTouchInterception.call(void 0, _CallControls.GenericBtn))
const DesktopMoreToggleWithTooltip =
  _uiUtils.withOnCallTooltip.call(void 0, 'top', 'More options', tooltipWrapperClassName)(_uiUtils.withTouchInterception.call(void 0, _CallControls.GenericBtn))
const EnhancedMobileMoreToggle = _uiUtils.withTouchInterception.call(void 0, _CallControls.GenericBtn)

const ignoredUIEvents = ['mousemove', 'touchstart']
const noop = () => { /* no-op */ }










































// Was a plain class component (no memo, as before). Instance fields are refs;
// the stable handlers read the latest props and state through `latest`, as
// the class read `this.props`/`this.state` when called (including from the
// throttled mouse-move handler and the hide timer).
const OnCall = (props) => {
  const {
    meetingState, meetingStates,
    isCamOn, isMicOn, isCamCycleAvailable,
    onCycleCam, onHangup, onToggleCam, onToggleMic,
    isScreenSharingAvailable, isScreenSharingOn,
    stopScreenSharing, onToggleScreenSharing,
    participants, isRoomEmpty,
    roomKey, roomLink, onRoomLinkCopy,
    onRoomShare, isNativeSharingAvailable,
    openSettingsModal,
    openNetstatsModal,
    openMobileMoreOptionsModal,
    isMinimizable = false, isMinimized = false, onMinimize = noop,
    canRemoveActiveSpeaker,
    activeSpeakerId, isActiveSpeakerPinned,
    activeSpeakerVideoTrackId,
    onActiveSpeakerManualChange,
    onActiveSpeakerPinModeToggle,
    activeSpeaker,
  } = props

  const [areCallControlsActiveState, setAreCallControlsActive] = _react.useState.call(void 0, true)
  const [isDesktopMoreModalOpen, setIsDesktopMoreModalOpen] = _react.useState.call(void 0, false)
  const [, forceUpdate] = _react.useReducer.call(void 0, (n) => n + 1, 0)

  const latest = _react.useRef.call(void 0, { props, areCallControlsActive: areCallControlsActiveState, isDesktopMoreModalOpen })
  _react.useLayoutEffect.call(void 0, () => {
    latest.current = { props, areCallControlsActive: areCallControlsActiveState, isDesktopMoreModalOpen }
  })

  // The active speaker's video is shown through one MediaStream per instance,
  // replaced (and the call re-rendered once) when the speaker or their video
  // track changes, like the class field. Created once, not per render.
  const activeSpeakerVideoStream = _react.useRef(null)
  if (activeSpeakerVideoStream.current === null) activeSpeakerVideoStream.current = new MediaStream()

  const hideControlsTimer = _react.useRef(undefined)
  const overlayRef = _react.useRef(null)

  const closeDesktopMoreModal = _react.useCallback.call(void 0, () => setIsDesktopMoreModalOpen(false), [])
  const hideControls = _react.useCallback.call(void 0, () => setAreCallControlsActive(false), [])
  const showControls = _react.useCallback.call(void 0, () => setAreCallControlsActive(true), [])

  // componentDidUpdate: only when the active speaker or their video track id
  // changed since the previous render (never on mount). The class checked
  // after every update; the deps only skip runs where nothing it compares
  // changed.
  const prevSpeaker = _react.useRef.call(void 0, { activeSpeakerId, activeSpeakerVideoTrackId })
  _react.useLayoutEffect.call(void 0, () => {
    const prev = prevSpeaker.current
    prevSpeaker.current = { activeSpeakerId, activeSpeakerVideoTrackId }
    if (
      prev.activeSpeakerId === activeSpeakerId &&
      prev.activeSpeakerVideoTrackId === activeSpeakerVideoTrackId
    ) return

    if (activeSpeaker.videoTrack) {
      const stream = activeSpeakerVideoStream.current
      stream
        .getTracks()
        .forEach(t => stream.removeTrack(t))
      activeSpeakerVideoStream.current = new MediaStream([activeSpeaker.videoTrack])
      forceUpdate()
    }
  }, [activeSpeakerId, activeSpeakerVideoTrackId, activeSpeaker.videoTrack])

  const handleToggleDesktopMoreModal = _react.useCallback.call(void 0, () =>
    setIsDesktopMoreModalOpen(s => !s), [])

  const handleRemoveCurrentParticipant = _react.useCallback.call(void 0, () => {
    const { onRemoveParticipant, activeSpeakerId: speakerId } = latest.current.props
    return onRemoveParticipant(speakerId)
  }, [])

  const handleOverlayTouch = _react.useCallback.call(void 0, () => {
    const { areCallControlsActive: areActive, isDesktopMoreModalOpen: isMoreOpen } = latest.current

    if (isMoreOpen) closeDesktopMoreModal()
    else setAreCallControlsActive(!areActive)
  }, [closeDesktopMoreModal])

  const handleOverlayClick = _react.useCallback.call(void 0, () =>
    latest.current.isDesktopMoreModalOpen && closeDesktopMoreModal(), [closeDesktopMoreModal])

  // One throttled handler per mounted call, like the class field (its
  // helpers are stable, so the initialiser's closure never goes stale).
  const [handleOverlayMouseMove] = _react.useState.call(void 0, () => _lodash.throttle.call(void 0, () => {
    const { isDesktopMoreModalOpen: isMoreOpen, areCallControlsActive: areActive } = latest.current
    if (isMoreOpen) return
    if (!areActive) showControls()
    clearTimeout(hideControlsTimer.current)
    hideControlsTimer.current = setTimeout(hideControls, 1900)
  }, 100))

  // componentDidMount / componentWillUnmount. Prevents onMouseMove from firing
  // on touch screens.
  _react.useLayoutEffect.call(void 0, () => {
    const overlay = overlayRef.current
    const preventDefault = (e) => e.preventDefault()
    if (overlay) overlay.addEventListener('touchstart', preventDefault)
    return () => { if (overlay) overlay.removeEventListener('touchstart', preventDefault) }
  }, [])

  const isJoining = meetingState === meetingStates.JOINING
  const isJoined = meetingState === meetingStates.JOINED
  const isPendingApproval = meetingState === meetingStates.PENDING_APPROVAL
  const isShareOverlayVisible = isRoomEmpty && !isScreenSharingOn && isJoined
  const areCallControlsActive = areCallControlsActiveState ||
    isShareOverlayVisible

  const isActiveSpeakerMe = activeSpeaker.local
  const isActiveSpeakerVideoOn = !!activeSpeaker.videoTrack
  const amISharingScreen = !!(isActiveSpeakerMe && activeSpeaker.isScreenParticipant)
  const activeSpeakerAudioTrack = activeSpeaker.audioTrack
  const shouldMirrorActiveSpeakerFeed = !!(
    isActiveSpeakerMe &&
    isActiveSpeakerVideoOn &&
    _videoCall.shouldMirrorCamFeed.call(void 0, activeSpeakerVideoStream.current)
  )

  const rootClassName = _classBuilder2.default.call(void 0, 
    "video-call--on-call-room blm--noselect",
    { 'grey-gradient': amISharingScreen },
  )
  const toggleMoreBtnClassName = _classBuilder2.default.call(void 0, 
    "video-call--on-call--toggle-more-btn",
    { hidden: !areCallControlsActive },
  )
  const desktopMoreToggleClassName = _classBuilder2.default.call(void 0, 
    "meeting--on-call--desktop-more-toggle",
    { hidden: !areCallControlsActive, active: isDesktopMoreModalOpen },
  )
  const viewControllsClassName = _classBuilder2.default.call(void 0, 
    "meeting--on-call--view-controls",
    { hidden: !areCallControlsActive },
  )
  const overlayClassName = _classBuilder2.default.call(void 0, 
    "video-call--overlay",
    { opaque: isShareOverlayVisible },
    { faded: areCallControlsActive },
  )

  return (
    _react2.default.createElement('div', { className: rootClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 238}}
      , _react2.default.createElement('div', { className: overlayClassName,
        ref: overlayRef,
        onTouchStart: handleOverlayTouch,
        onClick: handleOverlayClick,
        onMouseMove: handleOverlayMouseMove, __self: this, __source: {fileName: _jsxFileName, lineNumber: 239}}

        , _react2.default.createElement('div', { className: viewControllsClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 245}}
          ,  isMinimizable &&
            _react2.default.createElement(MinimizeCallBtnWithTooltip, { onClick: onMinimize, __self: this, __source: {fileName: _jsxFileName, lineNumber: 247}})
          
          ,  !isRoomEmpty &&
            _react2.default.createElement(PinActiveSpeakerBtnWithTooltip, {
              isActive: isActiveSpeakerPinned,
              onClick: onActiveSpeakerPinModeToggle, __self: this, __source: {fileName: _jsxFileName, lineNumber: 250}}
            )
          
        )
        , _react2.default.createElement('div', { className: "video-call--top-bar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 256}}
          ,  activeSpeakerId && !isRoomEmpty &&
            _react2.default.createElement(_SpeakerNameBar2.default, {
              name: activeSpeaker.name,
              audioTrack: activeSpeakerAudioTrack, __self: this, __source: {fileName: _jsxFileName, lineNumber: 258}}
            )
          
        )
        , _react2.default.createElement(EnhancedMobileMoreToggle, {
          className: toggleMoreBtnClassName,
          onClick: openMobileMoreOptionsModal,
          iconSrc: "/assets/icons/video/more-white.svg",
          iconAlt: "⋮", __self: this, __source: {fileName: _jsxFileName, lineNumber: 264}}
        )
        ,  isShareOverlayVisible &&
          _react2.default.createElement(_ShareOverlay2.default, {
            roomLink: roomLink,
            onRoomLinkCopy: onRoomLinkCopy,
            onRoomShare: onRoomShare,
            ignoredUIEvents: ignoredUIEvents,
            isNativeSharingAvailable: isNativeSharingAvailable, __self: this, __source: {fileName: _jsxFileName, lineNumber: 271}}
          )
        
        , _react2.default.createElement(_CallControls4.default, {
          areOpen: areCallControlsActive,
          isCamCycleAvailable: isCamCycleAvailable,
          isScreenSharingAvailable: isScreenSharingAvailable,
          isCamOn: isCamOn,
          isMicOn: isMicOn,
          isScreenSharingOn: isScreenSharingOn,
          onCycleCam: onCycleCam,
          onToggleCam: onToggleCam,
          onToggleMic: onToggleMic,
          onHangup: onHangup,
          onToggleScreenSharing: onToggleScreenSharing,
          ignoredUIEvents: ignoredUIEvents, __self: this, __source: {fileName: _jsxFileName, lineNumber: 279}}
        )
        , _react2.default.createElement(_DesktopMoreOptionsModal2.default, {
          isOpen: isDesktopMoreModalOpen,
          onClose: closeDesktopMoreModal,
          ignoredUIEvents: ignoredUIEvents,
          onRoomLinkCopy: onRoomLinkCopy,
          onOpenSettings: openSettingsModal,
          onOpenNetstats: openNetstatsModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 293}}
        )
        ,  !isRoomEmpty && isJoined &&
          _react2.default.createElement(_ParticipantsBoard2.default, {
            isHidden: !areCallControlsActive,
            ignoredUIEvents: ignoredUIEvents,
            roomKey: roomKey,
            participants: participants,
            activeParticipantId: activeSpeakerId,
            onParticipantPick: onActiveSpeakerManualChange, __self: this, __source: {fileName: _jsxFileName, lineNumber: 302}}
          )
        
        , _react2.default.createElement('div', { className: "meeting--on-call--desktop-controls", __self: this, __source: {fileName: _jsxFileName, lineNumber: 311}}
          ,  canRemoveActiveSpeaker &&
            _react2.default.createElement(RemoveParticipantBtnWithTooltip, {
              onClick: handleRemoveCurrentParticipant,
              className: "meeting--on-call--remove-participant-btn",
              iconSrc: "/assets/icons/video/remove-participant-white.svg",
              iconAlt: "X", __self: this, __source: {fileName: _jsxFileName, lineNumber: 313}}
            )
          
          , _react2.default.createElement(DesktopMoreToggleWithTooltip, {
            onClick: handleToggleDesktopMoreModal,
            className: desktopMoreToggleClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 320}}
          )
        )
      )
      , _react2.default.createElement(_CallContent2.default, {
        isPendingApproval: isPendingApproval,
        isJoining: isJoining,
        areCallControlsActive: areCallControlsActive,
        isCallMinimized: isMinimized,
        isActiveSpeakerFeedOn: isActiveSpeakerVideoOn,
        shouldMirrorActiveSpeakerFeed: shouldMirrorActiveSpeakerFeed,
        amISharingScreen: amISharingScreen,
        stopScreenSharing: stopScreenSharing,
        activeSpeakerVideoStream: activeSpeakerVideoStream.current, __self: this, __source: {fileName: _jsxFileName, lineNumber: 326}}
      )
    )
  )
}

exports. default = OnCall
